import { useEffect } from "react";
import { initColorScheme } from "@/shared/colorScheme";

/**
 * Initializes theme from localStorage + system preference and keeps
 * the `dark` class on <html>` in sync.
 */
export function ColorSchemeSync() {
  useEffect(() => initColorScheme(), []);
  return null;
}
